<div id="app-content-area" class="app-content-area">
  @if (appLoading$ | async) {
    <div class="dashly-loading-container">
      <img src="../assets/OLD_images/loading.gif" />
    </div>
  } @else if ((mobileAppVersionCompatible$ | async) === false) {
    <cp-mobile-app-version-not-compatible />
  } @else {
    <div class="mobile-safe-area-wrapper">
      <router-outlet />
    </div>
  }
</div>

<shared-toast class="pointer-events-none" />
